import React from 'react';
import PropTypes from 'prop-types';
import CheckboxWithLabelV2 from '../../../components/composite/FormSets/CheckboxWithLabelV2/CheckboxWithLabelV2';
import Language from '../../../components/Language/Language';
import { destinationInfo } from '../../../destructured-front-end-config';

const TermsOfServiceControlSet = ({ brand, termsOfService, setTermsOfService }) => {
  return (
    <CheckboxWithLabelV2
      id="Terms_of_Service__c"
      value={termsOfService}
      label={<Language category="copy" which="termsOfServiceBlurbUAM" brand={brand} options={{ destinationInfo }} />}
      onClick={() => setTermsOfService(!termsOfService)}
    />
  );
};

TermsOfServiceControlSet.propTypes = {
  brand: PropTypes.object.isRequired,
  termsOfService: PropTypes.bool.isRequired,
  setTermsOfService: PropTypes.func.isRequired,
};

export default TermsOfServiceControlSet;